"use client";

import React, { useState, useEffect } from "react";
import { usePathname } from "next/navigation";
import dynamic from "next/dynamic";

const DesktopHeader = dynamic(() => import("./Desktop"));
const DashboardHeader = dynamic(() => import("./Dashboard"));
const MobileHeader = dynamic(() => import("./Mobile"));

const CommonHeader = () => {
  const [isMobile, setIsMobile] = useState(false);
  const pathname = usePathname();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  if (isMobile) {
    return <MobileHeader />;
  }

  if (pathname.startsWith("/dashboard") || pathname.startsWith("/expired")) {
    return <DashboardHeader />;
  }

  return <DesktopHeader />;
};

export default CommonHeader;
